module.exports = __webpack_public_path__ + "img/icon_sportMenu_hockey.dfa8afcf.svg";